import React from "react";
import { Link } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Ripple } from "primereact/ripple";
import { appStoreLink, playStoreLink } from "../../Website/Utils/Info";

interface InfoModalProps {
    show: boolean;
    onClose: () => void;
    title: string;
    info: string;
    showAppLink?: boolean;
}

const InfoModal: React.FC<InfoModalProps> = ({
    show,
    onClose,
    title,
    info,
    showAppLink
}) => {
    return (
        <Dialog
            headerClassName="d-none"
            visible={show}
            className="custom_modal_dialog modal_dialog_md"
            onHide={onClose}
            dismissableMask
        >
            <div className="custom_modal_body">
                <button className="custom_modal_close position-absolute float p-ripple"
                    onClick={onClose}>
                    <i className="bi bi-x-lg"></i>
                    <Ripple />
                </button>

                <div className="use_case_feature_info">
                    <h6 className="review_head">{title}</h6>

                    <div className="message_alert_area">
                        <img src="/assets/images/alert_image.svg" alt="Subscription Alert!" />

                        <p className="review_paragraph text-center">
                            {info}
                        </p>

                        {showAppLink && (
                            <div className="mobile_apps_link_area">
                                <Link target="_blank" to={appStoreLink} className="mb_app_link p-ripple">
                                    <img src="/assets/images/website/home-page/app_store.svg" alt="App Store" loading="lazy" />
                                    <Ripple />
                                </Link>
                                <Link target="_blank" to={playStoreLink} className="mb_app_link p-ripple">
                                    <img src="/assets/images/website/home-page/play_store.svg" alt="Play Store" loading="lazy" />
                                    <Ripple />
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default InfoModal;